export const common = {
  // Navigation
  nav_features: '機能',
  nav_security: 'セキュリティ',
  nav_community: 'コミュニティ',
  nav_join: '参加する',
  nav_back_home: 'ホームに戻る',
  
  // Hero Section
  hero_title: 'FaceTrue',
  hero_subtitle: '本人確認型ソーシャルネットワーク',
  hero_description_1: '偽アカウントなし。誹謗中傷なし。暴力なし。',
  hero_description_2: '有害コンテンツなし。過激主義なし。',
  hero_description_3: '100%ポジティブ - AI認証。',
  
  // How It Works
  how_title: '仕組み',
  step1_title: '顔認証',
  step1_desc: 'セルフィー撮影 → AI本人確認 → 即座に認証',
  step1_badge: '偽アカウントなし',
  step2_title: 'クリーンなコンテンツ',
  step2_desc: 'AIが有害、詐欺、暴力コンテンツを24時間365日フィルタリング',
  step2_badge: 'AI 24/7フィルター',
  step3_title: 'グローバルコミュニティ',
  step3_desc: '国内またはグローバルに投稿',
  step3_badge: '世界の国々',
  
  // Age-Based Content
  age_title: '年齢別コンテンツ',
  children_label: '子供',
  children_title: '子供向け',
  children_feature1: '安全な教育コンテンツ',
  children_feature2: '親しみやすい環境',
  children_feature3: '保護者による監視',
  adults_label: '大人',
  adults_title: '大人向け',
  adults_feature1: '社会的議論',
  adults_feature2: 'キャリア＆ライフ',
  adults_feature3: 'グローバルな繋がり',
  seniors_label: 'シニア',
  seniors_title: 'シニア向け',
  seniors_feature1: '健康情報',
  seniors_feature2: '経験の共有',
  seniors_feature3: 'サポートコミュニティ',
  
  // Why Different
  why_title: 'FaceTrueを選ぶ理由',
  why_feature1_title: '100%本物の人',
  why_feature1_desc: 'AIによる本人確認で偽アカウントを排除',
  why_feature2_title: '暴力＆有害コンテンツなし',
  why_feature2_desc: 'AIが暴力、有害、誹謗中傷コンテンツを24時間365日フィルタリング',
  why_feature3_title: '過激主義なし',
  why_feature3_desc: 'あらゆる形態の過激主義と憎悪を排除',
  why_feature4_title: '100%ポジティブ',
  why_feature4_desc: 'ポジティブで建設的で健全なコンテンツのみ',
  why_feature5_title: '全年齢対応の安全性',
  why_feature5_desc: 'スマートなコンテンツ分類で各年齢層に適合',
  why_feature6_title: '3フラッグ警告システム',
  why_feature6_desc: '<span class="text-yellow-400 font-bold">イエローフラッグ</span>（1回目の違反）→ <span class="text-red-400 font-bold">レッドフラッグ</span>（2回目の違反）→ <span class="text-gray-400 font-bold">ブラックフラッグ</span>（3回目の違反 - アカウント凍結）',
  why_feature7_title: 'スター評価システム',
  why_feature7_desc: 'ポジティブな情報、画像、動画を共有 → コミュニティから<span class="text-pink-400 font-bold">ピンクハート型スター</span>を獲得',
  why_feature8_title: '真実の広告',
  why_feature8_desc: 'AIが広告の真実性をチェック。商品は投稿前に<span class="text-cyan-400 font-bold">出所確認</span>',
  
  // Video Demo
  video_title: 'FaceTrue デモビデオ',
  video_subtitle: '動作を見る',
  video_views: '回視聴',
  video_close: 'Xを押して閉じる',
  video_demo_live: 'ライブデモ',
  video_info: 'FaceTrue シミュレーションデモ',
  video_info_cta: '再生を押してデモを見る',
  video_update: '実際のビデオはVeo AIから更新されます',
  
  // Video Stages
  scanning_title: '認証中...',
  scanning_desc: 'AIが本人確認中',
  scanning_step1: '顔検出',
  scanning_step2: 'AI認証',
  scanning_step3: 'プロフィール作成中...',
  scanning_badge: '100% 本物の人',
  
  intro_step1_title: '認証成功',
  intro_step1_subtitle: '100%本物の人',
  intro_step2_title: 'AIコンテンツフィルター',
  intro_step2_subtitle: '有害・暴力コンテンツなし',
  intro_step3_title: 'グローバルな繋がり',
  intro_step3_subtitle: '119カ国',
  intro_step4_title: '100%ポジティブ',
  intro_step4_subtitle: '健全なコンテンツのみ',
  intro_step5_title: '全年齢対応の安全性',
  intro_step5_subtitle: '子供 • 大人 • シニア',
  
  stats_title: 'FaceTrue コミュニティ',
  stats_subtitle: '急成長中',
  stats_users: 'ユーザー',
  stats_countries: 'カ国',
  stats_posts: 'ポジティブな投稿',
  stats_badge: '100% ポジティブ',
  
  comparison_title: '違い',
  comparison_old: '従来のSNS',
  comparison_old_1: '偽アカウント',
  comparison_old_2: '有害コンテンツ',
  comparison_old_3: '暴力',
  comparison_old_4: '詐欺',
  comparison_new: 'FaceTrue',
  comparison_new_1: '100%本物の人',
  comparison_new_2: 'クリーンなコンテンツ',
  comparison_new_3: '100%ポジティブ',
  comparison_new_4: 'AI安全性',
  
  // Mock Posts
  mock_post1: '今日は素晴らしい日でした！ポジティブな環境を作ってくれたFaceTrueに感謝 🌟',
  mock_post2: '在宅勤務の効率的な経験を共有します。ヒントが必要な方はいますか？ 💼',
  mock_post3: '家族のための健康的なパンのレシピ。試した方はいますか？ 🍞',
  
  // CTA Section
  cta_title: '今すぐ参加',
  cta_subtitle: 'FaceTrue ベータ版に登録',
  cta_name: 'お名前',
  cta_email: 'メールアドレス',
  cta_button: '今すぐ登録',
  cta_submitting: '送信中...',
  cta_success: '🎉 ありがとうございます！すぐにご連絡いたします。',
  cta_error: '❌ エラーが発生しました。もう一度お試しください。',
  cta_privacy: 'お客様のプライバシーを尊重します',
  
  // Footer
  footer_copyright: '© 2025 FaceTrue グローバルソーシャルネットワーク',
  footer_creator: 'Created by Ben Nguyen',
  footer_powered: 'Website Builder',
  
  // Time
  time_hours_ago: '{{count}}時間前',
  time_day_ago: '{{count}}日前',
  
  // Children Page
  children_nav_features: '機能',
  children_nav_safety: '安全性',
  children_nav_activities: 'アクティビティ',
  children_back_home: 'ホームに戻る',
  
  children_hero_title: 'ようこそ',
  children_hero_subtitle: '小さな天使たち',
  children_hero_desc: '子供のために特別に設計された安全で楽しく教育的なスペース！<br />AIによる保護で100%保護者承認のコンテンツ。',
  children_explore_btn: '機能を探索',
  children_safety_btn: '安全第一',
  
  children_features_title: '楽しく教育的な機能',
  children_features_subtitle: '子供が安全に学び、遊び、成長するために必要なすべて',
  
  children_feature1_title: '教育コンテンツ',
  children_feature1_desc: '年齢に適した学習教材、楽しいクイズ、教育を楽しくするインタラクティブなレッスン。',
  
  children_feature2_title: '安全なゲーム',
  children_feature2_desc: '慎重に選ばれた楽しく教育的で子供に完全に安全なゲーム。',
  
  children_feature3_title: '創造的な活動',
  children_feature3_desc: 'お絵かき、塗り絵、ストーリーテリング、その他の創造的な活動で想像力を刺激。',
  
  children_safety_title: 'お子様の安全が最優先',
  children_safety_subtitle: '心配のない体験を保証する複数の保護層',
  
  children_safety1_title: 'AIコンテンツフィルター',
  children_safety1_desc: '24時間365日のAI監視により、適切なコンテンツのみが子供に届くことを保証。',
  
  children_safety2_title: '保護者による管理',
  children_safety2_desc: '保護者は活動を監視し、健全な使用時間制限を設定できます。',
  
  children_safety3_title: '知らない人なし',
  children_safety3_desc: '子供は確認済みの友達と家族のみと交流できます。',
  
  children_activities_title: '楽しいアクティビティを探索',
  children_activities_subtitle: 'アクティビティをクリックして詳細を確認し、遊び始めましょう！',
  
  // 8 Activities
  activity1_title: 'お絵かき＆アート',
  activity1_desc: 'デジタルツールで素晴らしいアート作品を作成',
  
  activity2_title: '教育ゲーム',
  activity2_desc: 'インタラクティブゲームで楽しく学ぶ',
  
  activity3_title: '物語＆読書',
  activity3_desc: '物語を通じて魔法の世界を探索',
  
  activity4_title: '音楽＆歌',
  activity4_desc: '楽しい歌とメロディーを発見',
  
  activity5_title: '写真＆ビデオ',
  activity5_desc: '特別な瞬間を撮影して共有',
  
  activity6_title: 'グループ活動',
  activity6_desc: '友達と一緒に遊んで学ぶ',
  
  activity7_title: 'チャレンジ＆報酬',
  activity7_desc: '楽しいチャレンジを完了して報酬を獲得',
  
  activity8_title: '特別イベント',
  activity8_desc: 'エキサイティングな季節のアクティビティに参加',
  
  children_footer_copyright: '© 2025 FaceTrue キッズエリア',
  children_footer_desc: '子供が学び遊ぶための安全なスペース',
  
  children_modal_safe_badge: '安全で楽しい',
  children_modal_what_you_can_do: 'できること',
  children_modal_start_btn: 'アクティビティを始める',
  
  // Adults Page
  adults_nav_features: '機能',
  adults_nav_community: 'コミュニティ',
  adults_nav_benefits: 'メリット',
  adults_back_home: 'ホームに戻る',
  
  adults_hero_title: '繋がる',
  adults_hero_subtitle: '本物の人、本物のストーリー',
  adults_hero_desc: '本物の体験を共有し、意味のある繋がりを築き、<br />共に成長する確認済み大人のコミュニティに参加しましょう。',
  adults_explore_btn: '機能を探索',
  adults_join_btn: 'コミュニティに参加',
  
  adults_features_title: '繋がるために必要なすべて',
  adults_features_subtitle: 'プロフェッショナルネットワーキング、ライフスタイル共有、意味のある会話',
  
  adults_feature1_title: 'キャリア＆プロフェッショナル',
  adults_feature1_desc: 'プロフェッショナルと繋がり、キャリアの洞察を共有し、あなたの分野で機会を発見しましょう。',
  
  adults_feature2_title: 'ライフスタイル＆趣味',
  adults_feature2_desc: '世界中の同じ志を持つ人々と情熱、趣味、日常生活を共有しましょう。',
  
  adults_feature3_title: '深い会話',
  adults_feature3_desc: '確認済みユーザーと重要なトピックについて意味のある議論に参加しましょう。',
  
  adults_community_title: 'グローバルコミュニティに参加',
  adults_community_subtitle: 'あなたの興味と価値観を共有する人々と繋がりましょう',
  
  adults_community_entrepreneurs: '起業家',
  adults_community_entrepreneurs_desc: 'ビジネスアイデア＆スタートアップ議論',
  adults_community_entrepreneurs_full: '世界中の革新的な思想家とビジネスリーダーと繋がりましょう。スタートアップのアイデアを共有し、ビジネス戦略を議論し、潜在的な共同創業者を見つけましょう。',
  adults_community_entrepreneurs_members: '125,000人以上のメンバー',
  adults_community_entrepreneurs_topic1: 'スタートアップアイデア',
  adults_community_entrepreneurs_topic2: '資金調達＆投資',
  adults_community_entrepreneurs_topic3: 'ビジネス戦略',
  adults_community_entrepreneurs_topic4: 'マーケティング＆成長',
  adults_community_entrepreneurs_topic5: '製品開発',
  
  adults_community_health: '健康＆ウェルネス',
  adults_community_health_desc: 'フィットネス、栄養＆メンタルヘルス',
  adults_community_health_full: '身体的・精神的健康に焦点を当てたサポートコミュニティに参加しましょう。ワークアウトルーチン、栄養のヒント、メンタルヘルスリソースを共有しましょう。',
  adults_community_health_members: '230,000人以上のメンバー',
  adults_community_health_topic1: 'フィットネス＆ワークアウト',
  adults_community_health_topic2: '栄養＆ダイエット',
  adults_community_health_topic3: 'メンタルヘルス',
  adults_community_health_topic4: 'ヨガ＆瞑想',
  adults_community_health_topic5: '健康的なライフスタイル',
  
  adults_community_arts: 'アート＆カルチャー',
  adults_community_arts_desc: '創造的表現＆文化交流',
  adults_community_arts_full: '創造性と文化的多様性を祝いましょう。あなたのアート作品を共有し、新しいアーティストを発見し、意味のある文化的議論に参加しましょう。',
  adults_community_arts_members: '180,000人以上のメンバー',
  adults_community_arts_topic1: 'ビジュアルアート',
  adults_community_arts_topic2: '音楽＆パフォーマンス',
  adults_community_arts_topic3: '文学',
  adults_community_arts_topic4: '映画＆写真',
  adults_community_arts_topic5: '文化交流',
  
  adults_community_travel: '旅行＆冒険',
  adults_community_travel_desc: '旅行体験＆ヒントを共有',
  adults_community_travel_full: '旅行愛好家と一緒に世界を発見しましょう。旅行体験を共有し、目的地の推奨を受け、旅行仲間を見つけましょう。',
  adults_community_travel_members: '310,000人以上のメンバー',
  adults_community_travel_topic1: '旅行のヒント',
  adults_community_travel_topic2: '目的地ガイド',
  adults_community_travel_topic3: '予算旅行',
  adults_community_travel_topic4: 'アドベンチャースポーツ',
  adults_community_travel_topic5: '文化体験',
  
  adults_community_food: '食べ物＆料理',
  adults_community_food_desc: 'レシピ、レストラン＆料理芸術',
  adults_community_food_full: '食通と家庭料理人のための美味しいコミュニティ。レシピを共有し、レストランをレビューし、料理の冒険を楽しみましょう。',
  adults_community_food_members: '275,000人以上のメンバー',
  adults_community_food_topic1: 'レシピ＆料理',
  adults_community_food_topic2: 'レストランレビュー',
  adults_community_food_topic3: 'ベーキング＆デザート',
  adults_community_food_topic4: '国際料理',
  adults_community_food_topic5: 'フードフォトグラフィー',
  
  adults_community_technology: 'テクノロジー',
  adults_community_technology_desc: 'テクノロジートレンド＆イノベーション',
  adults_community_technology_full: 'テクノロジーのトレンドとイノベーションの最前線に立ちましょう。最新のガジェット、プログラミング、AI、テクノロジーの未来について議論しましょう。',
  adults_community_technology_members: '195,000人以上のメンバー',
  adults_community_technology_topic1: 'プログラミング＆開発',
  adults_community_technology_topic2: 'AI＆機械学習',
  adults_community_technology_topic3: 'ガジェット＆レビュー',
  adults_community_technology_topic4: 'サイバーセキュリティ',
  adults_community_technology_topic5: 'テクノロジーニュース',
  
  adults_community_parenting: '子育て',
  adults_community_parenting_desc: '家族生活＆子育てのヒント',
  adults_community_parenting_full: 'あらゆる段階の親のためのサポートとアドバイス。子育てのヒント、課題を共有し、マイルストーンを一緒に祝いましょう。',
  adults_community_parenting_members: '340,000人以上のメンバー',
  adults_community_parenting_topic1: '子育てのヒント',
  adults_community_parenting_topic2: '子供の発達',
  adults_community_parenting_topic3: '教育',
  adults_community_parenting_topic4: '家族活動',
  adults_community_parenting_topic5: 'ワークライフバランス',
  
  adults_community_education: '教育',
  adults_community_education_desc: '学習＆個人の成長',
  adults_community_education_full: '生涯学習者が団結！教育リソースを共有し、学習戦略を議論し、一緒に成長しましょう。',
  adults_community_education_members: '210,000人以上のメンバー',
  adults_community_education_topic1: 'オンライン学習',
  adults_community_education_topic2: 'キャリア開発',
  adults_community_education_topic3: '言語学習',
  adults_community_education_topic4: '学術的議論',
  adults_community_education_topic5: '学習のヒント',
  
  adults_community_active: 'アクティブなコミュニティ',
  adults_community_join_btn: 'コミュニティに参加',
  adults_community_popular_topics: '人気のトピック',
  
  adults_benefits_title: '大人がFaceTrueを選ぶ理由',
  adults_benefits_subtitle: '本物の大人の繋がりのために構築されたソーシャルネットワーク',
  
  adults_benefit1_title: '確認済みアイデンティティ',
  adults_benefit1_desc: '全員が本物の人であることを知って自信を持って繋がりましょう。',
  
  adults_benefit2_title: '有害コンテンツなし',
  adults_benefit2_desc: 'AIフィルターがハラスメント、ヘイトスピーチ、ネガティブコンテンツを排除。',
  
  adults_benefit3_title: 'グローバルリーチ',
  adults_benefit3_desc: '世界119カ国の確認済みユーザーと繋がりましょう。',
  
  adults_benefit4_title: 'プライバシー優先',
  adults_benefit4_desc: 'あなたのデータは企業レベルのセキュリティ対策で保護されています。',
  
  adults_footer_copyright: '© 2025 FaceTrue 大人コミュニティ',
  adults_footer_desc: '世界中の確認済み大人との本物の繋がり',
  
  // Seniors Page
  seniors_nav_features: '機能',
  seniors_nav_health: '健康',
  seniors_nav_community: 'コミュニティ',
  seniors_back_home: 'ホームに戻る',
  
  seniors_hero_title: 'コミュニティ',
  seniors_hero_subtitle: 'シニアのために構築',
  seniors_hero_desc: 'あなたの知恵を共有し、愛する人と連絡を取り合い、<br />安全でサポート的なオンラインコミュニティをお楽しみください。',
  seniors_explore_btn: '機能を探索',
  seniors_safety_btn: '安全第一',
  
  seniors_features_title: 'FaceTrueでできること',
  seniors_features_subtitle: '繋がり、共有し、意味のある交流を楽しみましょう',
  
  seniors_feature1_title: '家族との繋がり',
  seniors_feature1_desc: '世界中の家族と連絡を取り合いましょう。安全な環境で写真、ビデオ、生活の最新情報を共有しましょう。',
  
  seniors_feature2_title: 'あなたのストーリーを共有',
  seniors_feature2_desc: 'あなたの人生経験、知恵、思い出を他の人と共有しましょう。あなたのストーリーは重要で、インスピレーションを与えます。',
  
  seniors_feature3_title: '新しい友達を作る',
  seniors_feature3_desc: 'あなたの興味と趣味を共有する人々と繋がりましょう。意味のある友情を築きましょう。',
  
  seniors_feature4_title: '地域イベント',
  seniors_feature4_desc: 'あなたの近くの地域コミュニティ活動とイベントを発見して参加しましょう。',
  
  seniors_feature5_title: '新しいスキルを学ぶ',
  seniors_feature5_desc: 'テクノロジー、趣味、日常生活スキルに関するチュートリアル、ヒント、ガイドにアクセスしましょう。',
  
  seniors_feature6_title: 'サポートグループ',
  seniors_feature6_desc: '健康、ウェルネス、人生の課題に関するサポートコミュニティに参加しましょう。あなたは一人ではありません。',
  
  seniors_health_title: '健康＆ウェルネスリソース',
  seniors_health_subtitle: '信頼できる情報で情報を得て健康を保ちましょう',
  
  seniors_health1_title: '健康のヒント',
  seniors_health1_desc: 'シニア向けに特別に設計された毎日の健康アドバイス、栄養のヒント、運動ガイド。',
  
  seniors_health2_title: 'メンタルヘルス',
  seniors_health2_desc: 'メンタルヘルスサポート、マインドフルネスの実践、ストレス管理。',
  
  seniors_health3_title: '薬のリマインダー',
  seniors_health3_desc: '薬と健康の予約のリマインダーを設定して追跡しましょう。',
  
  seniors_health4_title: 'アクティビティトラッカー',
  seniors_health4_desc: '毎日の活動、歩数を追跡し、健康のマイルストーンを祝いましょう。',
  
  seniors_community_title: 'あなたのコミュニティと繋がる',
  seniors_community_subtitle: 'サポートを見つけ、体験を共有し、意味のある繋がりを作りましょう',
  
  seniors_community_family: '家族との繋がり',
  seniors_community_family_desc: '家族と近くにいましょう',
  seniors_community_family_full: '世代を超えて家族と繋がりましょう。子供や孫と写真、ビデオ、思い出を共有しましょう。重要な家族のイベントとマイルストーンについて最新情報を入手しましょう。',
  seniors_community_family_members: '280万人のメンバー',
  seniors_community_family_topic1: '家族の最新情報',
  seniors_community_family_topic2: '写真共有',
  seniors_community_family_topic3: 'ビデオ通話',
  seniors_community_family_topic4: '家族イベント',
  seniors_community_family_topic5: '孫のストーリー',
  
  seniors_community_stories: 'あなたのストーリーを共有',
  seniors_community_stories_desc: '人生経験＆知恵',
  seniors_community_stories_full: 'あなたの人生経験、知恵、ストーリーを若い世代と共有しましょう。あなたの思い出とレッスンは、他の人にインスピレーションと指導を与えることができる貴重な宝物です。',
  seniors_community_stories_members: '190万人のメンバー',
  seniors_community_stories_topic1: '人生のストーリー',
  seniors_community_stories_topic2: '歴史的出来事',
  seniors_community_stories_topic3: 'キャリア経験',
  seniors_community_stories_topic4: '人生のレッスン',
  seniors_community_stories_topic5: '家族の歴史',
  
  seniors_community_friends: '新しい友達を作る',
  seniors_community_friends_desc: '世界中の友達と繋がる',
  seniors_community_friends_full: 'あなたの興味、趣味、人生経験を共有する他のシニアと出会い、繋がりましょう。意味のある友情を築き、社会的繋がりを楽しみましょう。',
  seniors_community_friends_members: '320万人のメンバー',
  seniors_community_friends_topic1: '友情',
  seniors_community_friends_topic2: '社会活動',
  seniors_community_friends_topic3: '共通の興味',
  seniors_community_friends_topic4: 'グループチャット',
  seniors_community_friends_topic5: 'ミートアップ',
  
  seniors_community_events: '地域イベント',
  seniors_community_events_desc: 'コミュニティ活動＆集まり',
  seniors_community_events_full: 'あなたの地域のシニア向けに設計された地域イベント、活動、集まりを発見しましょう。アクティブで地域コミュニティと関わりましょう。',
  seniors_community_events_members: '150万人のメンバー',
  seniors_community_events_topic1: 'コミュニティイベント',
  seniors_community_events_topic2: 'シニアセンター',
  seniors_community_events_topic3: '社会的集まり',
  seniors_community_events_topic4: '地域活動',
  seniors_community_events_topic5: 'ワークショップ',
  
  seniors_community_learning: '新しいスキルを学ぶ',
  seniors_community_learning_desc: '成長と学習を止めない',
  seniors_community_learning_full: '学習を止めないでください！シニア向けに特別に設計された簡単なチュートリアル、オンラインクラス、教育コンテンツにアクセスしましょう。自分のペースで学びましょう。',
  seniors_community_learning_members: '210万人のメンバー',
  seniors_community_learning_topic1: 'テクノロジー基礎',
  seniors_community_learning_topic2: 'アート＆クラフト',
  seniors_community_learning_topic3: '料理クラス',
  seniors_community_learning_topic4: '言語学習',
  seniors_community_learning_topic5: '趣味',
  
  seniors_community_support: 'サポートグループ',
  seniors_community_support_desc: '理解と励ましを見つける',
  seniors_community_support_full: '同様の健康状態や人生の状況を共有する他の人からサポートと理解を見つけましょう。体験を共有し、感情的なサポートを受けましょう。',
  seniors_community_support_members: '170万人のメンバー',
  seniors_community_support_topic1: '健康サポート',
  seniors_community_support_topic2: '悲しみのサポート',
  seniors_community_support_topic3: '介護者サポート',
  seniors_community_support_topic4: '慢性疾患',
  seniors_community_support_topic5: 'メンタルヘルス',
  
  seniors_community_popular_topics: '人気のトピック：',
  seniors_community_join_btn: 'コミュニティに参加',
  
  seniors_benefits_title: 'シニアがFaceTrueを愛する理由',
  seniors_benefits_subtitle: 'あなたの経験を尊重し、評価するソーシャルネットワーク',
  
  seniors_benefit1_title: '詐欺や詐欺なし',
  seniors_benefit1_desc: '詐欺師や詐欺行為に対するAI保護。',
  
  seniors_benefit2_title: '大きくて明確なテキスト',
  seniors_benefit2_desc: '快適な閲覧のために設計された読みやすいインターフェース。',
  
  seniors_benefit3_title: '24時間365日サポート',
  seniors_benefit3_desc: 'サポートが必要なときはいつでもヘルプが利用可能です。',
  
  seniors_benefit4_title: 'プライバシー保護',
  seniors_benefit4_desc: 'あなたの個人情報は常に安全でプライベートに保たれます。',
  
  seniors_benefit5_title: '尊重するコミュニティ',
  seniors_benefit5_desc: '人々がお互いを尊重して扱うポジティブな環境。',
  
  seniors_benefit6_title: '無料で使用',
  seniors_benefit6_desc: 'すべての機能があなたのために無料で利用可能です。',
  
  seniors_footer_copyright: '© 2025 FaceTrue シニアコミュニティ',
  seniors_footer_desc: 'シニアが繋がるための安全でサポート的なスペース',
};

export default common;